<app-spinner></app-spinner>

<div class="track-container position-relative text-center">
  <img
    src="/assets/img/resources/track/track_banner.jpg"
    alt=""
    class="img-fluid"
  />

  <div
    class="tracking-form position-absolute top-50 start-50 translate-middle w-75"
  >
    <form
      [formGroup]="invoiceForm"
      (ngSubmit)="loadInvoiceStatuses()"
      novalidate
    >
      <div class="input-group shadow-lg">
        <input
          #input
          id="invoiceno"
          type="text"
          class="form-control"
          name="tracking_number"
          placeholder="Enter your transaction number"
          formControlName="invoice"
          autofocus
        />
        <button class="btn btn-success btn-lg px-4" type="submit">Track</button>
      </div>
    </form>

    <div class="text-center mt-5">
      <a
        routerLink="/track-unregistered-box"
        class="btn btn-outline-light btn-sm rounded-pill px-4 py-2 track-unreg-cta"
      >
        Track an abandoned box? Click here!
      </a>
    </div>
  </div>
</div>

<!-- Tracking Section -->
<div class="bg-light pt-4 pb-4">
  <div class="container">
    <!-- Invoice Not Found -->
    <div
      class="row justify-content-center"
      *ngIf="result != null && result.invoice == null"
    >
      <div class="col-md-10 col-lg-8">
        <div class="card border-0 shadow-sm">
          <div class="card-body p-4">
            <div class="d-flex align-items-start">
              <div class="flex-shrink-0 me-3">
                <div
                  class="d-flex align-items-center justify-content-center rounded-circle bg-warning bg-opacity-10"
                  style="width: 60px; height: 60px; padding: 10px"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
                    <path
                      d="M183.1 137.4C170.6 124.9 150.3 124.9 137.8 137.4C125.3 149.9 125.3 170.2 137.8 182.7L275.2 320L137.9 457.4C125.4 469.9 125.4 490.2 137.9 502.7C150.4 515.2 170.7 515.2 183.2 502.7L320.5 365.3L457.9 502.6C470.4 515.1 490.7 515.1 503.2 502.6C515.7 490.1 515.7 469.8 503.2 457.3L365.8 320L503.1 182.6C515.6 170.1 515.6 149.8 503.1 137.3C490.6 124.8 470.3 124.8 457.8 137.3L320.5 274.7L183.1 137.4z"
                    />
                  </svg>
                </div>
              </div>

              <div class="flex-grow-1">
                <h5 class="card-title text-dark mb-2">
                  <strong>Invoice Not Found</strong>
                </h5>
                <p class="card-text text-muted mb-3">
                  We couldn't locate an invoice with the number you provided.
                  This might happen if:
                </p>
                <ul class="list-unstyled text-muted mb-3">
                  <li class="mb-1">
                    • The invoice number was entered incorrectly
                  </li>
                  <li class="mb-1">
                    • The invoice is from a different account
                  </li>
                  <li>• There may be a system delay in processing</li>
                </ul>

                <div class="d-flex flex-wrap gap-2 align-items-center">
                  <button class="btn btn-outline-primary btn-sm">
                    <i class="fas fa-redo me-1"></i>
                    Try Again
                  </button>

                  <span class="text-muted small">or</span>

                  <a
                    href="tel:{{ telephone }}"
                    class="btn btn-link btn-sm text-decoration-none p-0"
                  >
                    <i class="fas fa-phone me-1"></i>
                    Call Support: {{ telephone }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Tracking Results -->
    <div
      *ngIf="result != null && result.invoice != null"
      class="tracking-results"
    >
      <!-- Status Header -->
      <div
        *ngIf="result != null && result.invoice != null"
        class="tracking-results"
      >
        <!-- Status Header -->
        <div class="row justify-content-center mb-4">
          <div class="col-md-10 col-lg-8">
            <div class="card border-0 shadow-sm">
              <div class="card-body text-center py-5">
                <div class="mb-3">
                  <i
                    class="fas fa-box text-success"
                    style="font-size: 2rem"
                  ></i>
                </div>

                <h2 class="text-success fw-bold mb-2">{{ getMainStatus() }}</h2>

                <!-- Progress Bar -->
                <div
                  class="progress-container mb-4"
                  [ngClass]="'step-' + getCompletedStepsCount()"
                >
                  <div
                    class="d-flex justify-content-between align-items-center position-relative"
                  >
                    <!-- Progress Line -->
                    <div class="progress-line"></div>

                    <!-- Step 1: Pickup -->
                    <div
                      class="progress-step"
                      [class.completed]="isStepCompleted('pickup')"
                    >
                      <div class="step-circle">
                        <i
                          class="fas fa-check"
                          *ngIf="isStepCompleted('pickup')"
                        ></i>
                      </div>
                    </div>

                    <!-- Step 2: In Transit -->
                    <div
                      class="progress-step"
                      [class.completed]="isStepCompleted('intransit')"
                    >
                      <div class="step-circle">
                        <i
                          class="fas fa-check"
                          *ngIf="isStepCompleted('intransit')"
                        ></i>
                      </div>
                    </div>

                    <!-- Step 3: Port -->
                    <div
                      class="progress-step"
                      [class.completed]="isStepCompleted('port')"
                    >
                      <div class="step-circle">
                        <i
                          class="fas fa-check"
                          *ngIf="isStepCompleted('port')"
                        ></i>
                      </div>
                    </div>

                    <!-- Step 4: Hub Transfer (NEW STEP) -->
                    <div
                      class="progress-step"
                      [class.completed]="isStepCompleted('hubTransfer')"
                    >
                      <div class="step-circle">
                        <i
                          class="fas fa-check"
                          *ngIf="isStepCompleted('hubTransfer')"
                        ></i>
                      </div>
                    </div>

                    <!-- Step 5: Local Delivery -->
                    <div
                      class="progress-step"
                      [class.completed]="isStepCompleted('localDelivery')"
                    >
                      <div class="step-circle">
                        <i
                          class="fas fa-check"
                          *ngIf="isStepCompleted('localDelivery')"
                        ></i>
                      </div>
                    </div>

                    <!-- Step 6: Delivered -->
                    <div
                      class="progress-step"
                      [class.completed]="isStepCompleted('delivered')"
                    >
                      <div class="step-circle">
                        <i
                          class="fas fa-check"
                          *ngIf="isStepCompleted('delivered')"
                        ></i>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Step Labels -->
                <!-- Step Labels -->
                <div
                  class="row d-flex justify-content-center small text-muted text-center"
                >
                  <div class="col-2">
                    {{
                      result.invoice.serviceTypeCode === "DROPOFF"
                        ? "Drop Off"
                        : "Pick Up"
                    }}
                  </div>

                  <div class="col-2">In Transit</div>
                  <div class="col-2">At Port</div>
                  <div class="col-2">Hub Transfer</div>
                  <div class="col-2">Out for Delivery</div>

                  <!-- FIXED: Delivered label added -->
                  <div class="col-2">Delivered</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Shipping Details -->
      <div class="row justify-content-center mb-4">
        <div class="col-md-10 col-lg-8">
          <div class="card border-0 shadow-sm">
            <div class="card-body p-4">
              <div class="row">
                <div class="col-md-6">
                  <h6 class="fw-bold text-uppercase text-muted mb-3">
                    Sender Information
                  </h6>
                  <address class="mb-0">
                    <strong>{{ result.invoice.customerFullname }}</strong
                    ><br />
                    {{ result.invoice.billingAddress }}<br />
                    {{ result.invoice.billingCity }},
                    {{ result.invoice.billingState }}<br />
                    {{ result.invoice.billingCountry }}
                    {{ result.invoice.billingZipCode }}
                  </address>
                </div>
                <div class="col-md-6">
                  <h6 class="fw-bold text-uppercase text-muted mb-3">
                    Consignee Information
                  </h6>
                  <address class="mb-0">
                    <strong>{{ result.invoice.consigneeName }}</strong
                    ><br />
                    {{ result.invoice.consigneeAddress }}<br />
                    {{ result.invoice.consigneeCity }},
                    {{ result.invoice.consigneeBrgy }}<br />
                    {{ result.invoice.consigneeState }},
                    {{ result.invoice.consigneeCountry }}
                    {{ result.invoice.consigneeZipcode }}
                  </address>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Tracking History -->
      <div class="row justify-content-center">
        <div class="col-md-10 col-lg-8">
          <div class="card border-0 shadow-sm">
            <div class="card-body p-0">
              <!-- Tab Navigation -->
              <ul class="nav nav-tabs border-bottom-0" role="tablist">
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link active border-0 border-bottom-3 border-primary fw-semibold px-4 py-3"
                    data-bs-toggle="tab"
                    data-bs-target="#pick-up-status"
                    type="button"
                    role="tab"
                  >
                    Pick-up Information
                  </button>
                </li>

                <li
                  class="nav-item"
                  role="presentation"
                  *ngIf="result.shipmentH.length > 0"
                >
                  <button
                    class="nav-link border-0 border-bottom-3 fw-semibold px-4 py-3 text-muted"
                    data-bs-toggle="tab"
                    data-bs-target="#shipment-status"
                    type="button"
                    role="tab"
                  >
                    Shipment Information
                  </button>
                </li>

                <li
                  class="nav-item"
                  role="presentation"
                  *ngIf="result.deliveries.length > 0"
                >
                  <button
                    class="nav-link border-0 border-bottom-3 fw-semibold px-4 py-3 text-muted"
                    data-bs-toggle="tab"
                    data-bs-target="#delivery-status"
                    type="button"
                    role="tab"
                  >
                    Delivery Status
                  </button>
                </li>

                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link border-0 border-bottom-3 fw-semibold px-4 py-3 text-muted"
                    data-bs-toggle="tab"
                    data-bs-target="#invoice-details"
                    type="button"
                    role="tab"
                  >
                    Invoice Details
                  </button>
                </li>
              </ul>

              <!-- Tab Content -->
              <div class="tab-content">
                <!-- Pick-up Status Tab -->
                <div
                  class="tab-pane fade show active p-4"
                  id="pick-up-status"
                  role="tabpanel"
                >
                  <!-- Status Timeline -->
                  <div class="tracking-timeline">
                    <div class="timeline-item">
                      <!-- Invoice received in warehouse -->
                      <div
                        class="row align-items-start mb-4"
                        *ngIf="
                          result.invoice.serviceTypeCode.toLowerCase() ===
                            'dropoff' && result.invoice.isInWarehouse
                        "
                      >
                        <div class="col-md-2 text-muted small">
                          {{
                            result.invoice.inWarehouseDate
                              | date: "MMMM dd, yyyy"
                          }}
                        </div>
                        <div class="col-md-8">
                          <span class="text-success"
                            >Package has arrived in warehouse.</span
                          >
                        </div>
                        <div class="col-md-2">
                          {{ result.invoice.noOfBoxes }}
                        </div>
                      </div>

                      <!-- Box transfer from branch to driver -->
                      <div
                        class="row align-items-start mb-4"
                        *ngIf="
                          result.invoice.serviceTypeCode.toLowerCase() ===
                            'dropoff' &&
                          !result.invoice.isInWarehouse &&
                          result.invoice.inDriverHubDate &&
                          result.invoice.driverHubDriver
                        "
                      >
                        <div class="col-md-2 text-muted small">
                          {{
                            result.invoice.inDriverHubDate
                              | date: "MMMM dd, yyyy"
                          }}
                        </div>
                        <div class="col-md-8">
                          <span class="text-success"
                            >Package is now being transferred from branch to
                            warehouse.
                          </span>
                          <br />
                          <span class="text-success"
                            >Driver:
                            <strong>{{
                              result.invoice.driverHubDriver
                            }}</strong>
                          </span>
                        </div>
                        <div class="col-md-2">
                          {{ result.invoice.noOfBoxes }}
                        </div>
                      </div>

                      <!-- Invoice received by driver -->
                      <div
                        class="row align-items-start mb-4"
                        *ngIf="
                          result.invoice.serviceTypeCode.toLowerCase() ===
                            'pickup' && result.invoice.isPickupReceived
                        "
                      >
                        <div class="col-md-2 text-muted small">
                          {{
                            result.invoice.actualPickupDate
                              | date: "MMMM dd, yyyy"
                          }}
                        </div>
                        <div class="col-md-8">
                          <span class="text-success"
                            >Package has been picked up by driver.</span
                          >
                          <br />
                          <span
                            >Driver:
                            <strong>{{ result.invoice.driver }}</strong>
                          </span>
                        </div>
                        <div class="col-md-2">
                          {{ result.invoice.noOfBoxes }}
                        </div>
                      </div>

                      <!-- Invoice received by branch -->
                      <div
                        class="row align-items-start mb-4"
                        *ngIf="
                          result.invoice.serviceTypeCode.toLowerCase() ===
                            'dropoff' && result.invoice.actualDropoffDate
                        "
                      >
                        <div class="col-md-2 text-muted small">
                          {{
                            result.invoice.actualDropoffDate
                              | date: "MMMM dd, yyyy"
                          }}
                        </div>
                        <div class="col-md-8">
                          <span class="text-success"
                            >Package has been dropped off to
                            <strong>{{ result.invoice.assignedBranch }}</strong>
                            branch.
                          </span>
                          <br />
                          <span>
                            Confirmed by:
                            <strong>{{
                              result.invoice.dropOffReceivedBy
                            }}</strong>
                          </span>
                        </div>
                        <div class="col-md-2">
                          {{ result.invoice.noOfBoxes }}
                        </div>
                      </div>

                      <!-- Driver assigned to invoice -->
                      <div
                        class="row align-items-start mb-4"
                        *ngIf="
                          result.invoice.serviceTypeCode.toLowerCase() ===
                            'pickup' &&
                          result.invoice.isPickupAssigned &&
                          result.invoice.driver
                        "
                      >
                        <div class="col-md-2 text-muted small">
                          {{
                            result.invoice.pickupAssignDate
                              | date: "MMMM dd, yyyy"
                          }}
                        </div>
                        <div class="col-md-8">
                          <span class="text-success"
                            >A driver has been assigned to your invoice.</span
                          ><br />
                          <span
                            >Assigned Driver:
                            <strong>{{ result.invoice.driver }}</strong>
                          </span>
                        </div>
                        <div class="col-md-2">
                          {{ result.invoice.noOfBoxes }}
                        </div>
                      </div>

                      <!-- Invoice created -->
                      <div class="row align-items-start">
                        <div class="col-md-2 text-muted small">
                          {{
                            result.invoice.dateCreated | date: "MMMM dd, yyyy"
                          }}
                        </div>
                        <div class="col-md-8">
                          <span class="text-success"
                            >Invoice has been created.</span
                          >
                        </div>
                        <div class="col-md-2">
                          {{ result.invoice.noOfBoxes }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Shipment Status Tab -->
                <div
                  class="tab-pane fade p-4"
                  id="shipment-status"
                  role="tabpanel"
                >
                  <!-- Status Timeline -->
                  <div class="tracking-timeline">
                    <div
                      class="timeline-item"
                      *ngFor="let shipment of result.shipmentH"
                    >
                      <div
                        class="alert alert-warning shadow-sm p-3"
                        *ngIf="shipment.comments?.length"
                      >
                        <strong class="d-block mb-2">Advisory</strong>

                        <div class="advisory">
                          <div
                            *ngFor="let c of shipment.comments"
                            class="advisory-item mb-3"
                          >
                            <div class="advisory-dot bg-warning"></div>
                            <div class="advisory-content">
                              <div class="fw-semibold">
                                {{ c.tdate | date: "mediumDate" }}
                              </div>
                              <div>{{ c.comment }}</div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Warehouse Decon -->
                      <div
                        class="row align-items-start"
                        *ngIf="shipment?.deconRcvD?.noOfBoxes > 0"
                      >
                        <div class="col-md-2 text-muted small">
                          {{ shipment.deconRcvD.date | date: "MMMM dd, yyyy" }}
                        </div>
                        <div class="col-md-8">
                          <span class="text-success">
                            Package has been received at
                            {{ shipment.deconRcvD.warehouse }}
                            Warehouse</span
                          >
                          <br />
                          <span class="text-danger"
                            >* Please allow below number of days for Warehouse
                            Sorting and Processing:</span
                          >
                          <ul class="text-danger" style="margin-left: 1.5rem">
                            <li>• Metro Manila - 1-3 days</li>
                            <li>• Luzon - 3-6 days</li>
                            <li>• Visayas & Mindanao - 10-15 days</li>
                          </ul>

                          <br />
                        </div>
                        <div class="col-md-2">
                          {{ shipment.deconRcvD.noOfBoxes }}
                        </div>
                      </div>

                      <!-- Container Status -->
                      <!-- Manila -->
                      <div
                        class="row align-items-start mb-4"
                        *ngIf="shipment.phReceivedManilaDate"
                      >
                        <div class="col-md-2 text-muted small">
                          {{
                            shipment.phReceivedManilaDate
                              | date: "MMMM dd, yyyy"
                          }}
                        </div>
                        <div class="col-md-8">
                          <span class="text-success"
                            >Container arrived in Manila Warehouse</span
                          >
                          <br />
                          <span
                            *ngIf="
                              filterAdvisories(shipment.advisories, 'arrive')
                                .length
                            "
                          >
                            <div
                              *ngFor="
                                let advisory of filterAdvisories(
                                  shipment.advisories,
                                  'arrive'
                                )
                              "
                              class="text-danger"
                            >
                              • {{ advisory }}
                            </div>
                          </span>
                        </div>
                        <div class="col-md-2"></div>
                      </div>

                      <!-- Tarlac -->
                      <div
                        class="row align-items-start mb-4"
                        *ngIf="shipment.phReceivedTarlacDate"
                      >
                        <div class="col-md-2 text-muted small">
                          {{
                            shipment.phReceivedTarlacDate
                              | date: "MMMM dd, yyyy"
                          }}
                        </div>
                        <div class="col-md-8">
                          <span class="text-success"
                            >Container arrived at Tarlac Warehouse<br />
                            <span
                              *ngIf="
                                filterAdvisories(shipment.advisories, 'arrive')
                                  .length
                              "
                            >
                              <div
                                *ngFor="
                                  let advisory of filterAdvisories(
                                    shipment.advisories,
                                    'arrive'
                                  )
                                "
                                class="text-danger"
                              >
                                • {{ advisory }}
                              </div>
                            </span>
                          </span>
                        </div>
                        <div class="col-md-2"></div>
                      </div>

                      <!-- Tarlac -->
                      <div
                        class="row align-items-start mb-4"
                        *ngIf="shipment.phReceivedDavaoDate"
                      >
                        <div class="col-md-2 text-muted small">
                          {{
                            shipment.phReceivedDavaoDate | date: "MMMM dd, yyyy"
                          }}
                        </div>
                        <div class="col-md-8">
                          <span class="text-success"
                            >Container arrived at Davao Warehouse<br />
                            <span
                              *ngIf="
                                filterAdvisories(shipment.advisories, 'arrive')
                                  .length
                              "
                            >
                              <div
                                *ngFor="
                                  let advisory of filterAdvisories(
                                    shipment.advisories,
                                    'arrive'
                                  )
                                "
                                class="text-danger"
                              >
                                • {{ advisory }}
                              </div>
                            </span>
                          </span>
                        </div>
                        <div class="col-md-2"></div>
                      </div>

                      <!-- Customs -->
                      <div
                        class="row align-items-start mb-4"
                        *ngIf="shipment.phCustomsDate"
                      >
                        <div class="col-md-2 text-muted small">
                          {{ shipment.phCustomsDate | date: "MMMM dd, yyyy" }}
                        </div>
                        <div class="col-md-8">
                          <span class="text-success"
                            >Released at Customs - En Route to Warehouse<br />
                            <span
                              *ngIf="
                                filterAdvisories(shipment.advisories, 'release')
                                  .length
                              "
                            >
                              <div
                                *ngFor="
                                  let advisory of filterAdvisories(
                                    shipment.advisories,
                                    'release'
                                  )
                                "
                                class="text-danger"
                              >
                                • {{ advisory }}
                              </div>
                            </span>
                          </span>
                        </div>
                        <div class="col-md-2"></div>
                      </div>

                      <!-- Manila Airport -->
                      <div
                        class="row align-items-start mb-4"
                        *ngIf="shipment.manilaAirportDate"
                      >
                        <div class="col-md-2 text-muted small">
                          {{
                            shipment.manilaAirportDate | date: "MMMM dd, yyyy"
                          }}
                        </div>
                        <div class="col-md-8">
                          <span class="text-success"
                            >Container arrived at Manila Airport <br />

                            <span
                              *ngIf="
                                filterAdvisories(shipment.advisories, 'port')
                                  .length
                              "
                            >
                              <div
                                *ngFor="
                                  let advisory of filterAdvisories(
                                    shipment.Advisories,
                                    'port'
                                  )
                                "
                                class="text-danger"
                              >
                                • {{ advisory }}
                              </div>
                            </span>
                          </span>
                        </div>
                        <div class="col-md-2"></div>
                      </div>

                      <!-- Manila Port -->
                      <div
                        class="row align-items-start mb-4"
                        *ngIf="shipment.manilaPortDate"
                      >
                        <div class="col-md-2 text-muted small">
                          {{ shipment.manilaPortDate | date: "MMMM dd, yyyy" }}
                        </div>
                        <div class="col-md-8">
                          <span class="text-success"
                            >Shipment arrived at the Port of Manila <br />
                            <span
                              *ngIf="
                                filterAdvisories(shipment.advisories, 'port')
                                  .length
                              "
                            >
                              <div
                                *ngFor="
                                  let advisory of filterAdvisories(
                                    shipment.advisories,
                                    'port'
                                  )
                                "
                                class="text-danger"
                              >
                                • {{ advisory }}
                              </div>
                            </span>
                          </span>
                        </div>
                        <div class="col-md-2"></div>
                      </div>

                      <div
                        class="row align-items-start mb-4"
                        *ngIf="shipment.davaoPortDate"
                      >
                        <div class="col-md-2 text-muted small">
                          {{ shipment.davaoPortDate | date: "MMMM dd, yyyy" }}
                        </div>
                        <div class="col-md-8">
                          <span class="text-success"
                            >Shipment arrived at the Port of Davao <br />
                            <!-- <span class="text-danger">
                                • Please allow 2-6 working days for Bureau of Customs processing/releasing.
                              </span> -->
                            <span
                              *ngIf="
                                filterAdvisories(shipment.advisories, 'port')
                                  .length
                              "
                            >
                              <div
                                *ngFor="
                                  let advisory of filterAdvisories(
                                    shipment.advisories,
                                    'port'
                                  )
                                "
                                class="text-danger"
                              >
                                • {{ advisory }}
                              </div>
                            </span>
                          </span>
                        </div>
                        <div class="col-md-2"></div>
                      </div>

                      <div
                        class="row align-items-start mb-4"
                        *ngIf="shipment.inTransitDate"
                      >
                        <div class="col-md-2 text-muted small">
                          {{ shipment.inTransitDate | date: "MMMM dd, yyyy" }}
                        </div>
                        <div class="col-md-8">
                          <span class="text-success"
                            >Shipment is in transit to the Philippines <br />
                            <span class="text-danger">
                              * Estimated Time of Arrival at the Port of Manila:
                              {{ shipment.eta | date: "MM/dd/yyyy" }}
                            </span>
                            <span
                              *ngIf="
                                filterAdvisories(shipment.advisories).length
                              "
                            >
                              <div
                                *ngFor="
                                  let advisory of filterAdvisories(
                                    shipment.advisories
                                  )
                                "
                                class="text-danger"
                              >
                                • {{ advisory }}
                              </div>
                            </span>
                          </span>
                        </div>
                        <div class="col-md-2"></div>
                      </div>
                    <ng-container *ngIf="shipment.lastShipRefStatusCode != 'OPEN'">
                      <div class="row align-items-start mb-4">
                        <div class="col-md-2 text-muted small">
                          {{ shipment.receivedDate | date: "MMMM dd, yyyy" }}
                        </div>
                        <div class="col-md-8">
                          <span class="text-success"
                            >Package has been loaded in the container</span
                          >
                        </div>
                        <div class="col-md-2">{{ shipment.noOfBoxes }}</div>
                      </div>
                    </ng-container>
                    </div>
                  </div>
                </div>

                <!-- Delivery Status Tab -->
                <div
                  class="tab-pane fade p-4"
                  id="delivery-status"
                  role="tabpanel"
                  *ngIf="result.deliveries.length > 0"
                >
                  <!-- Status Timeline -->
                  <div class="tracking-timeline">
                    <div
                      class="timeline-item"
                      *ngFor="let delivery of result.deliveries"
                    >
                      <ng-container *ngIf="delivery.type === 'CustomerPickUp'">
                        <ng-container *ngIf="delivery.completedNoOfBoxes > 0">
                          <div class="row align-items-start mb-4">
                            <div class="col-md-2 text-muted small">
                              {{
                                delivery.completedDate | date: "MMMM dd, yyyy"
                              }}
                            </div>
                            <div class="col-md-8">
                              <span class="text-success"
                                ><strong
                                  >Package has been picked up by
                                  {{ delivery.consignee }} at
                                  {{ delivery.branch }} Branch</strong
                                >
                              </span>
                            </div>
                            <div class="col-md-2">
                              {{ delivery.completedNoOfBoxes }}
                            </div>
                          </div>
                        </ng-container>
                      </ng-container>

                      <div
                        class="row align-items-start mb-4"
                        *ngIf="
                          delivery.type === 'DeliveryPoint' &&
                          delivery.completedNoOfBoxes > 0
                        "
                      >
                        <div class="col-md-2 text-muted small">
                          {{
                            delivery.dpid != "MANUALUPDATES"
                              ? (delivery.completedDate | date: "MMMM dd, yyyy")
                              : "-"
                          }}
                        </div>
                        <div class="col-md-8">
                          <span class="text-success"
                            >Package has been delivered</span
                          >
                        </div>
                        <div class="col-md-2">
                          {{ delivery.completedNoOfBoxes }}
                        </div>
                      </div>

                      <div
                        class="row align-items-start mb-4"
                        *ngIf="
                          delivery.type === 'DeliveryPoint' &&
                          delivery.inTransitNoOfBoxes > 0
                        "
                      >
                        <div class="col-md-2 text-muted small">
                          {{
                            delivery.dpid != "MANUALUPDATES"
                              ? (delivery.inTransitDate | date: "MMMM dd, yyyy")
                              : "-"
                          }}
                        </div>
                        <div class="col-md-8">
                          <span class="text-success"
                            ><span *ngIf="delivery.deliveryAttempts.length > 0">
                              <i
                                class="fa fa-times-circle fa-lg text-danger me-1"
                              ></i>
                              <strong class="text-danger"
                                >FAILED DELIVERY ATTEMPT</strong
                              >
                              <span
                                *ngIf="delivery.deliveryAttempts.length > 0"
                              >
                                <div
                                  *ngFor="let item of delivery.deliveryAttempts"
                                >
                                  [Reason] {{ item.note }}
                                </div>
                              </span>
                            </span>
                            <!--End Delivery Attempts-->

                            <span *ngIf="!delivery.deliveryAttempts.length > 0">
                              Your package is out for delivery.
                              <br />
                              It will take a while depending on your consignees
                              location.<br />
                            </span>
                            [Driver] {{ delivery.driverName }} <br />

                            <span *ngIf="delivery.advisories.length > 0">
                              <div
                                *ngFor="let advisory of delivery.advisories"
                                class="text-danger"
                              >
                                • {{ advisory }}
                              </div>
                            </span>
                          </span>
                        </div>
                        <div class="col-md-2">
                          {{ delivery.inTransitNoOfBoxes }}
                        </div>
                      </div>

                      <ng-container *ngIf="delivery.type === 'HubTransfer'">
                        <div
                          class="row align-items-start mb-4"
                          *ngIf="
                            delivery.completedNoOfBoxes &&
                            delivery.completedNoOfBoxes > 0
                          "
                        >
                          <div class="col-md-2 text-muted small">
                            {{ delivery.completedDate | date: "MMMM dd, yyyy" }}
                          </div>
                          <div class="col-md-8">
                            <span class="text-success"
                              ><div>
                                Package has been received at
                                {{ delivery.destination }}
                              </div>
                              <div class="text-danger">
                                • Sorting and processing are currently underway.
                                Please wait for further updates.
                              </div>
                            </span>
                          </div>
                          <div class="col-md-2">
                            {{ delivery.completedNoOfBoxes }}
                          </div>
                        </div>

                        <div
                          class="row align-items-start mb-4"
                          *ngIf="
                            delivery.isArriveAtWarehouse &&
                            delivery.inTransitNoOfBoxes > 0
                          "
                        >
                          <div class="col-md-2 text-muted small">
                            {{
                              delivery.completedDate
                                ? (delivery.completedDate
                                  | date: "MMMM d, yyyy")
                                : (delivery.eta | date: "MMMM dd, yyyy")
                            }}
                          </div>
                          <div class="col-md-8">
                            <span class="text-success"
                              >Package has arrived at
                              {{ delivery.destination }}</span
                            >
                          </div>
                          <div class="col-md-2">
                            {{ delivery.inTransitNoOfBoxes }}
                          </div>
                        </div>

                        <div
                          class="row align-items-start mb-4"
                          *ngIf="delivery.inTransitNoOfBoxes > 0"
                        >
                          <div class="col-md-2 text-muted small">
                            {{ delivery.inTransitDate | date: "MMMM dd, yyyy" }}
                          </div>
                          <div class="col-md-8">
                            <span class="text-success"
                              >Package is in transit to {{ delivery.destination
                              }}<br />
                              [ETA:
                              {{ delivery.eta | date: "MMMM dd, yyyy" }}]
                              <span *ngIf="delivery.advisories.length > 0">
                                <div
                                  *ngFor="let advisory of delivery.advisories"
                                  class="text-danger"
                                >
                                  • {{ advisory }}
                                </div>
                              </span>
                            </span>
                          </div>
                          <div class="col-md-2">
                            {{ delivery.inTransitNoOfBoxes }}
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>

                <!-- Invoice Details Tab -->
                <div
                  class="tab-pane fade p-4"
                  id="invoice-details"
                  role="tabpanel"
                >
                  <div class="row">
                    <div class="col-md-6">
                      <table class="table table-borderless">
                        <tr>
                          <td class="text-muted">Invoice Number:</td>
                          <td>
                            <strong>{{ result.invoice.invoiceNo }}</strong>
                          </td>
                        </tr>
                        <tr>
                          <td class="text-muted">Service Type:</td>
                          <td>{{ result.invoice.serviceTypeCode }}</td>
                        </tr>
                        <tr>
                          <td class="text-muted">Number of Boxes:</td>
                          <td>{{ result.invoice.noOfBoxes }}</td>
                        </tr>
                        <tr>
                          <td class="text-muted">Box Details:</td>
                          <td>{{ result.invoice.boxes }}</td>
                        </tr>
                      </table>
                    </div>
                    <div class="col-md-6">
                      <table class="table table-borderless">
                        <!-- <tr>
                          <td class="text-muted">Total Amount:</td>
                          <td>
                            <strong>${{ result.invoice.totalAmount }}</strong>
                          </td>
                        </tr> -->
                        <tr>
                          <td class="text-muted">Pickup Date:</td>
                          <td>
                            {{
                              result.invoice.actualPickupDate | date: "medium"
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td class="text-muted">Driver:</td>
                          <td>{{ result.invoice.driver }}</td>
                        </tr>
                        <tr>
                          <td class="text-muted">Branch:</td>
                          <td>{{ result.invoice.assignedBranch }}</td>
                        </tr>
                      </table>
                    </div>
                  </div>

                  <!-- Shipment Details -->
                  <!-- <div
                    class="mt-4"
                    *ngIf="result.shipmentH && result.shipmentH.length > 0"
                  >
                    <h6 class="fw-bold mb-3">Shipment Details</h6>
                    <div
                      *ngFor="let shipment of result.shipmentH"
                      class="border rounded p-3 mb-3"
                    >
                      <div class="row">
                        <div class="col-md-6">
                          <p>
                            <strong>Shipment No:</strong>
                            {{ shipment.shipmentNo }}
                          </p>
                          <p>
                            <strong>Carrier:</strong>
                            {{ shipment.carrierVoyageNo }}
                          </p>
                          <p>
                            <strong>Load Date:</strong>
                            {{ shipment.loadDate | date : "medium" }}
                          </p>
                        </div>
                        <div class="col-md-6">
                          <p>
                            <strong>ETA:</strong>
                            {{ shipment.eta | date : "medium" }}
                          </p>
                          <p>
                            <strong>ETD:</strong>
                            {{ shipment.etd | date : "medium" }}
                          </p>
                          <p>
                            <strong>Status:</strong>
                            <span class="badge bg-success">{{
                              shipment.lastShipRefStatusDescription
                            }}</span>
                          </p>
                        </div>
                      </div>

                      <div
                        *ngIf="
                          shipment.advisories && shipment.advisories.length > 0
                        "
                        class="mt-3"
                      >
                        <h6 class="text-warning">Advisories:</h6>
                        <ul class="list-unstyled">
                          <li
                            *ngFor="let advisory of shipment.advisories"
                            class="small text-muted mb-1"
                          >
                            • {{ advisory }}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
